/**
 * Shape of a `streamIdentifier`, e.g. `JUKE1234` — the thing printed on a table talker. Only used
 * to decide, client-side, whether manual entry should skip straight to `createSession` or go
 * through `GET /venues/search` instead. The server is the actual source of truth for whether a
 * ref resolves; this is purely a UX branch, not validation.
 */
const VENUE_CODE_PATTERN = /^JUKE[0-9]+$/i;

export function isVenueCode(input: string): boolean {
  return VENUE_CODE_PATTERN.test(input.trim());
}
